<template>
  <div class="customer-service-pop">
    <!-- <div class="bg-icon" /> -->
    <div class="first_title">{{ $t('contact.lxkf06') }}</div>
    <div class="second_title">{{ $t('contact.lxkf07') }}</div>
    <div class="list">
      <div class="item">
        <div class="left">
          <div class="icon2" />
          <div>{{ $t('contact.lxkf02') }}</div>
        </div>
        <div class="right" @click="openNew(telgramurl)">{{ $t('contact.lxkf04') }}
        </div>
      </div>
      <div class="item">
        <div class="left">
          <div class="icon1" />
          <div>{{ $t('contact.lxkf01') }}</div>
        </div>
        <div class="right" @click="openNew(onlineurl)">{{ $t('contact.lxkf04') }}
        </div>
      </div>
      <div class="item">
        <div class="left">
          <div class="icon2" />
          <div>{{ $t('contact.lxkf05') }}</div>
        </div>
        <div class="right" @click="openNew(viptelurl)">{{ $t('contact.lxkf04') }}
        </div>
      </div>
      <div class="item">
        <div class="left">
          <div class="icon3" />
          <div>{{ $t('contact.lxkf03') }}</div>
        </div>
        <div class="right" @click="openNew(officialurl)">{{ $t('contact.lxkf04') }}
        </div>
      </div>
      <!-- <div class="item">
        <div class="left">
          <div class="icon4" />
          <div>WhatsApp</div>
        </div>
        <div class="right" @click="openNew(whatsappurl)">{{ $t('contact.lxkf04') }}
        </div>
      </div> -->
    </div>
    <div class="close-icon" name="cross" @click="$emit('close')" />
  </div>
</template>
<script>
import { getServerUrl } from '@/api/user'
export default {
  props: {
    isRoute: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      telgramurl: '',
      officialurl: '',
      onlineurl: '',
      whatsappurl: '',
      viptelurl: ''
    }
  },
  async created() {
    const res = await getServerUrl({ isRoute: this.isRoute })
    this.telgramurl = res.telgramurl
    this.officialurl = res.officialurl
    this.onlineurl = res.onlineurl
    this.whatsappurl = res.whatsappurl
    this.viptelurl = res.viptelurl
  },
  methods: {
    openNew(url) {
      window.open(url)
    }
  }
}
</script>
<style lang="less" >
.customer-service-pop{
    height: 688px;
    width: 574px;
    padding-bottom: 10px;
    // background: #202a41;
    background: var(--service-pop-bg);
    background-size: 100% 100%;
    // border-radius: 28px;
    display: flex;
    flex-direction: column;
    .first_title{
      font-family: AlibabaPuHuiTi_3_105_Heavy;
      font-size: 36px;
      color: #F6F1FF;
      line-height: 52px;
      font-weight: 900;
      margin: 54px 0 0 42px;
    }
    .second_title{
      font-family: AlibabaPuHuiTi_3_55_Regular;
      font-size: 32px;
      color: #F6F1FF;
      line-height: 48px;
      font-weight: 400;
      margin: 0 0 0 42px;
    }
    .close-icon{
        position: absolute;
        // top: 24px;
        // right: 24px;
        bottom: -92px;
        left: calc(50% - 16px);
        z-index: 9;
        height: 52px;
        width:52px;
        background: url(~@/assets/portal/auth/icon_close.svg);
        background-size: 100% 100%;
    }
    .bg-icon {
        position: absolute;
        top: 0;
        right: 20px;
        width: 680px;
        height: 560px;
        background: url(~@/assets/portal/customerService/customer_service_bg.png) no-repeat 50%;
        background-size: 100% 100%;
        z-index: 2;
    }
    .icon {
        height: 360px;
    }
    .list {
        position: relative;
        // width: 450px;
        z-index: 99;
        // top: 500px;
        margin: 58px 32px 0 32px;
        .item {
            margin-top: 16px;
            // padding: 0 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 508px;
            height: 96px;
            background: var(--service-pop-border);
            background-size: 100% 100%;
            .left {
                display: flex;
                align-items: center;
                font-family: PingFangSC-Regular;
                font-size: 28px;
                color: #F6F1FF;
                font-weight: 400;
                .icon1 {
                    margin: 16px 16px 16px 24px;
                    width: 64px;
                    height: 64px;
                    background: url(~@/assets/portal/auth/icon_在线客服.png) no-repeat 50%;
                    background-size: 100% 100%;
                }
                .icon2 {
                  margin: 16px 16px 16px 24px;
                    width: 64px;
                    height: 64px;
                    background: url(~@/assets/portal/auth/icon_TG客服.png) no-repeat 50%;
                    background-size: 100% 100%;
                }
                .icon3 {
                  margin: 16px 16px 16px 24px;
                    width: 64px;
                    height: 64px;
                    background: url(~@/assets/portal/auth/icon_官方频道.png) no-repeat 50%;
                    background-size: 100% 100%;
                }
                .icon4 {
                    margin-right: 20px;
                    width: 40px;
                    height: 42px;
                    background: url(~@/assets/portal/customerService/WhatsAPP.png) no-repeat 50%;
                    background-size: 100% 100%;
                }
            }
            .right {
                height: 48px;
                width: 136px;
                display: flex;
                align-items: center;
                justify-content: center;
                background-image: var(--btn-bg-color);
                border-radius: 8px;
                font-family: PingFangSC-Medium;
                font-size: 24px;
                color: var(--btn-text-color);
                text-align: center;
                line-height: 48px;
                font-weight: 500;
                margin-right:24px;
                .btn_jinru {
                    margin-left: 20px;
                    width: 14px;
                    height: 20px;
                    background: url(~@/assets/portal/customerService/btn_jinru2.png) no-repeat 50%;
                    background-size: 100% 100%;
                }
            }
        }
        .item:last-child{
          border-bottom: none;
        }
    }
}
.van-popup {
    overflow-y: initial;
    background-color: transparent;
}
</style>
